import React from 'react'
import { Separator } from '@fs/zion-ui'
import EditableDataBlock from '../shared/EditableDataBlock'

export default function ReviewLoadingFragment() {
  return (
    <>
      <EditableDataBlock loading />
      <Separator size="md" />
      <EditableDataBlock loading />
      <Separator size="lg" />
    </>
  )
}
